export default {
    // Endpoints
    loginEndpoint: '/auth/login',
    optVerificationEndpoint: '/auth/opt-verification',
    logoutEndpoint: '/auth/logout',
    userEnpoint: '/auth/user',

    forgetPasswordEndpoint: '/auth/forget-password',
    resetPasswordEndpoint: '/auth/reset-password',

    // This will be prefixed in authorization header with token
    tokenType: 'Bearer',

    // Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken'
}
